import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { deleteDocumentVisualization, openDocumentVisualizationModal, fetchDocumentVisualizations } from '../../../actions/masters/documentVisualization/documentVisualization'
import DocumentVisualizationMaster from '../../../components/masters/documentVisualization/DocumentVisualizationMaster'
import { fetchDocumentTypeUseCombo, fetchSearchDossierSubType } from '../../../actions/combos/combos'
export function mapStateToProps (state) {
  return {
    ...state.documentVisualization,
    combos: {
      dossierSubtypesCombo: state.combos.searchDossierSubtypesCombo,
      documentTypeUseCombo: state.combos.documentTypeUseCombo
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      deleteDocumentVisualization,
      openDocumentVisualizationModal,
      fetchDocumentVisualizations,
      fetchDocumentTypeUseCombo,
      fetchSearchDossierSubType
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(DocumentVisualizationMaster))
